import { MicrofrontendApplicationsHost, User } from '@digital-services/micro-frontend-applications-host';
import { useAuthorizationContext, usePageContext } from '@digital-services/shell';
import { useEffect, useState } from 'react';

const microfrontends = [
  {
    name: '@emobility/factory-process-service',
    route: 'factory-process-service'
  }
];

export const Main = () => {
  const { userData, getAccessToken } = useAuthorizationContext();
  const [user, setUser] = useState<User | null>(null);
  const { setTitle, setBreadcrumbs } = usePageContext();

  useEffect(() => {
    setUser(
      userData
        ? {
            id: userData.id,
            name: userData.name,
            language: userData.language,
            organizationId: userData.organizationId
          }
        : null
    );
  }, [userData]);

  if (!user) return null;

  return (
    <div className="flex flex-row flex-1 gap-4 p-12 pt-4 transition-all duration-200">
      <MicrofrontendApplicationsHost
        className="flex flex-1 flex-col overflow-auto"
        microfrontends={microfrontends}
        user={user}
        getAccessToken={getAccessToken}
        setTitle={setTitle}
        setBreadcrumbs={setBreadcrumbs}
      />
    </div>
  );
};
